"use client";

import Link from "next/link";
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle, Badge } from "../ui";
import { Check } from "lucide-react";

const PricingTiers = () => {
  const tiers = [
    {
      name: "Starter",
      price: "$29",
      description: "Perfect for small teams getting started",
      features: [
        "Up to 5 team members",
        "10GB storage",
        "Basic analytics",
        "Email support",
        "Standard workflows"
      ],
      cta: "/client/start",
      popular: false
    },
    {
      name: "Professional",
      price: "$79",
      description: "Ideal for growing businesses",
      features: [
        "Up to 25 team members",
        "100GB storage",
        "Advanced analytics",
        "Priority support",
        "Custom workflows",
        "API access",
        "Advanced integrations"
      ],
      cta: "/pro/start",
      popular: true
    },
    {
      name: "Enterprise",
      price: "Custom",
      description: "For large organizations with specific needs",
      features: [
        "Unlimited team members",
        "Unlimited storage",
        "Enterprise analytics",
        "24/7 dedicated support",
        "Custom integrations",
        "SSO & compliance",
        "On-premise deployment"
      ],
      cta: "/client/start",
      popular: false
    }
  ];

  return (
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
      {tiers.map((tier) => (
        <Card key={tier.name} className={`relative ${tier.popular ? 'border-primary shadow-lg scale-105' : ''}`}>
          {tier.popular && (
            <Badge className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-primary text-primary-foreground">
              Most Popular
            </Badge>
          )}
          <CardHeader className="text-center">
            <CardTitle className="text-2xl">{tier.name}</CardTitle>
            <div className="text-4xl font-bold">
              {tier.price}
              {tier.price !== "Custom" && <span className="text-lg font-normal text-muted-foreground">/month</span>}
            </div>
            <CardDescription>{tier.description}</CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <ul className="space-y-3">
              {tier.features.map((feature) => (
                <li key={feature} className="flex items-center gap-3">
                  <Check className="h-4 w-4 text-primary" />
                  <span className="text-sm">{feature}</span>
                </li>
              ))}
            </ul>
            <Button asChild className="w-full" variant={tier.popular ? "default" : "outline"}>
              <Link href={tier.cta}>
                Get Started
              </Link>
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default PricingTiers;
